import React, {useEffect, useState } from "react";
import { getOrganizations, addOrganization } from "../../utils/helper";
import Loader from "../../utils/Loader";
import { useHistory } from "react-router-dom";
import { alertSuccess, alertError } from '../../utils/alerts';
import { states } from "../../utils/dataFile";

const INIT_STATE = {
    name: null,
    email: null,
    phone: null,
    address: null,
    industry:null,
    state:"",
    country: "",
    assignedEmail: "",
};

export default function Organizations() {
    const [loading, setLoading] = useState(false);
    const [organizations, setOrganizations] = useState(null);
    const history = useHistory();
    const [state, setState] = useState(INIT_STATE);

    useEffect(() => {
        setLoading(true);
        getOrganizations()
            .then((res) => { 
                setOrganizations(res.data.data);  
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            })
            .catch((err) => {
                console.log(err?.response)
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            });
    }, []);

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    const navigateById = (path, id) => {
        history.push(`${path}/${id}`);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = { ...state };
        if(data.name && data.email && data.phone && data.address && data.industry && data.state && data.country && data.assignedEmail){
            setLoading(true);
            addOrganization(data)
            .then((res) => {
                if(res.data.success){
                    alertSuccess(res.data.message);
                    window.location.reload();
                } else {
                    alertError(res.data.message)
                }
                setLoading(false);
                setTimeout(() => {
                    setLoading(false);
                }, 1500);
            })
            .catch((err) => {
                alertError(err?.response?.data?.error);
                setLoading(false);
            });
        }
    };


    return (
        <>
            <div className="spur-card-menu">
                <button data-toggle="modal" data-target="#modal" type="button" className="pull-right btn topbtn btn-primary">CREATE</button>
            </div>
            
            <h1 className="dash-title">Outsourcing</h1>

            <div className="row dash-row">
                
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Organizations</div>
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {(!loading && organizations && organizations) ? 
                                    <div className="table-responsive">
                                        {(organizations && organizations.length > 0) ?
                                        <table className="table text-left text-caps table-bordered" id="myTable">
                                            <thead><tr><th>SN</th><th>Name</th><th>Email</th><th>Phone</th><th>Industry</th><th>Address</th><th>State</th>
                                            <th>Country</th><th>View</th></tr></thead>
                                            <tbody>
                                                {organizations && organizations.map((row, index) => 
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{row?.name && row?.name}</td>
                                                        <td>{row?.email && row?.email}</td>
                                                        <td>{row?.phone && row?.phone}</td>
                                                        <td>{row?.industry && row?.industry}</td>
                                                        <td>{row?.address && row?.address}</td>
                                                        <td>{row?.state && row?.state}</td> 
                                                        <td>{row?.country && row?.country}</td> 
                                                        <td>
                                                            <button 
                                                                onClick={() => navigateById("/outsourcing/organization", row._id)} 
                                                                className='btn btn-preview'
                                                                // disabled
                                                            >
                                                                    <i className="fa fa-eye"></i> View
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table> : 
                                        <div className="alert alert-danger myerror d-block">No record found.</div> }
                                    </div>
                                : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            
            <div id="modal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">ADD ORGANIZATION</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Name <span>*</span></label>
                                    <input type="text" name="name" className="form-control" required placeholder="Name of Organization" 
                                     onChange={handleChange} defaultValue={state.name && state.name} disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Email <span>*</span></label>
                                    <input type="email" name="email" className="form-control" required placeholder="Email of Organization" 
                                     onChange={handleChange} defaultValue={state.email && state.email }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Phone <span>*</span></label>
                                    <input type="tel" name="phone" maxLength={11} className="form-control" required placeholder="Phone of Organization" 
                                     onChange={handleChange} defaultValue={state.phone && state.phone }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Address <span>*</span></label>
                                    <input type="text" name="address" className="form-control" required placeholder="Address of Organization" 
                                     onChange={handleChange} defaultValue={state.address && state.address }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Industry <span>*</span></label>
                                    <input type="text" name="industry" className="form-control" required placeholder="Industry of Organization" 
                                     onChange={handleChange} defaultValue={state.industry && state.industry }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">State <span>*</span></label>
                                    <select className="form-control form-select" name="state" id="state" required 
                                    onChange={handleChange} defaultValue={state.state && state.state} disabled={loading}>
                                        <option value=''>Select...</option>
                                        {states && states.map((item, i) => (
                                            <option key={i} value={item.label}>{item.label}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Country <span>*</span></label>
                                    <select className="form-control form-select" name="country" id="country" required 
                                    onChange={handleChange} defaultValue={state.country && state.country} disabled={loading}>
                                        <option value=''>Select...</option>
                                        <option value="Nigeria">Nigeria</option>
                                        <option value="Ghana">Ghana</option>
                                    </select>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Assigned Email <span>*</span></label>
                                    <select className="form-control form-select" name="assignedEmail" id="assignedEmail" required 
                                    onChange={handleChange} defaultValue={state.assignedEmail && state.assignedEmail} disabled={loading}>
                                        <option value=''>Select...</option>
                                        <option value="kroutsourcing@kimberly-ryan.net">kroutsourcing@kimberly-ryan.net</option>
                                        <option value="fbnemployees@kimberly-ryan.net">fbnemployees@kimberly-ryan.net</option>
                                        <option value="ubnemployees@kimberly-ryan.net">ubnemployees@kimberly-ryan.net</option>
                                        <option value="abngemployees@kimberly-ryan.net">abngemployees@kimberly-ryan.net</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <button 
                                        type="submit" 
                                        className="btn" 
                                        disabled={loading}
                                        onClick={handleSubmit} >Create</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </>
    );
}
